<template>
  <q-page-sticky v-if="$isDesktop" position="top" expand class="top-bar bg-neutral-5">
    <q-toolbar class="page-toolbar">
      <slot>
        <breadcrumb-list />
      </slot>
      <q-space />
      <div class="page-toolbar__actions col-shrink">
        <slot name="actions" />
        <icon-button
            v-if="$slots.menu_items"
            icon="more_vert"
            text-color="neutral-90"
            size="md"
            aria-label="Toon menu"
            round
        >
          <actionable-menu>
            <slot name="menu_items" />
          </actionable-menu>
        </icon-button>
      </div>
    </q-toolbar>
  </q-page-sticky>
</template>

<script>
import BreadcrumbList from '../breadcrumbs/BreadcrumbList'

export default {
  components: { BreadcrumbList },
}
</script>
